<template>
  <div class="artwork-item d-flex">
    <div class="">
      <div class="image">
        <el-upload
          ref="uploader"
          action="#"
          :auto-upload="false"
          :on-change="handleChange"
          :file-list="fileList"
          list-type="picture-card"
          accept=".jpeg,.jpg,.png,.gif"
        >
          <i slot="default" class="el-icon-plus"></i>
          <div
            slot="file"
            slot-scope="{ file }"
            class="imagesViewer"
            v-viewer="{ movable: true }"
          >
            <img
              class="el-upload-list__item-thumbnail"
              :src="file.url"
              alt=""
            />
            <span class="el-upload-list__item-actions">
              <!-- <span class="el-upload-list__item-delete">
                <i class="el-icon-refresh"></i>
              </span> -->
              <span class="el-upload-list__item-preview" @click="onPreview">
                <i class="el-icon-zoom-in"></i>
              </span>
              <!-- <span class="el-upload-list__item-delete" @click="onDelete">
                <i class="el-icon-delete"></i>
              </span> -->
            </span>
          </div>
        </el-upload>
      </div>
      <!-- <div class="mt-4 opt-buttons">
        <div class="icon-button" @click="onDelete">
          <i class="el-icon-delete text-danger font-weight-bold"></i>
        </div>
      </div> -->
    </div>
    <div class="right ml-2 w-100">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="80px"
        size="mini"
        label-position="top"
      >
        <el-row :gutter="15">
          <el-col :span="18">
            <el-form-item
              :label="$l('INDEX.evg_sku_label_fileName') || '文件名称'"
              prop="fileName"
            >
              <el-input v-model="form.fileName" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.evg_sku_label_fileSize') || '文件大小'"
              prop="fileSize"
            >
              <el-input :value="fileSizeFormat" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item
          :label="$l('INDEX.evg_sku_label_fileDesc') || '文件说明'"
          prop="fileDesc"
        >
          <el-input
            ref="fileDescRef"
            v-model="form.fileDesc"
            :readonly="form.readonly"
            maxLength="500"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="d-flex justify-content-between align-items-center">
        <div class="text-secondary flex-fill" style="font-size: 12px;">
          <span v-if="form.modifyTime">
            Modify by:{{ item.modifyByName }} at {{ form.modifyTime }}
          </span>
        </div>
        <div class="d-flex">
          <div class="mx-2 d-flex">
            <template v-if="!unsaved">
              <div class="icon-button text-black-50" @click="onPreview">
                <i class="el-icon-view"></i>
              </div>
              <div class="icon-button text-black-50" @click="onDownload">
                <i class="el-icon-download"></i>
              </div>
            </template>

            <div class="icon-button text-black-50" @click="onDelete">
              <i class="el-icon-delete"></i>
            </div>
          </div>
          <el-button
            v-if="form.readonly"
            type="primary"
            size="mini"
            @click="onEdit"
            >{{
              $l('INDEX.evg_sku_label_edit_descriptionc') || '编辑说明'
            }}</el-button
          >
          <el-button v-else type="success" size="mini" @click="onSave">{{
            $l('INDEX.btn_save') || '保存'
          }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { sizeOf } from '@/libs/util'
import validate from '@/libs/util.validate'
export default {
  props: {
    index: Number,
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: this.item,
      rules: {
        fileDesc: [
          {
            required: true,
            message:
              this.$l('INDEX.evg_sku_label_please_fill_description') ||
              '请填写文件说明',
          },
        ],
      },
      fileList: [],
      readonly: true,
    }
  },
  computed: {
    unsaved() {
      return !this.form.evgSkuMaterialImgCode
    },
    fileSizeFormat() {
      return this.form.fileSize ? sizeOf(this.form.fileSize) : 0
    },
  },
  created() {
    if (this.item.displayImageUrl) {
      this.fileList.push({ url: this.item.displayImageUrl })
    }
  },
  watch: {
    fileList: {
      handler(val) {
        if (val && val.length) {
          this.$nextTick(() => {
            this.$refs.uploader.$refs['upload-inner'].$el.className += ' d-none'
          })
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleChange(file) {
      if (file.status !== 'ready') {
        return
      }
      this.form.fileName = file.name
      this.form.fileSize = file.size
      this.form.file = file.raw
      this.fileList = [file]
    },
    onPreview(index) {
      const viewer = this.$el.querySelector('.imagesViewer').$viewer
      viewer.view(index)
      viewer.show()
    },
    onDownload() {
      window.open(this.item.originImageUrl)
    },
    onDelete() {
      this.$emit('delete', { index: this.index })
    },
    onEdit() {
      this.form.readonly = false
      this.$refs.fileDescRef.focus()
    },
    async onSave() {
      const result = await this.validate()
      if (!result) return
      this.$emit('save', this.form)
    },
    validate() {
      return validate.formValidate([this.$refs.form])
    },
  },
}
</script>
<style scoped>
.image {
  /* width: 100px;
  height: 100px; */
}
.artwork-item {
  background-color: rgba(244, 246, 249, 1);
  padding: 20px;
}
.opt-buttons {
  display: flex;
  justify-content: center;
}
.icon-button {
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.icon-button i {
  font-size: 20px;
}
</style>
